import React, { useState } from "react";
import Lottie from "lottie-react";
import chatlogo from "./chatbot.json";
import ChatBotBox from "./ChatBotBox";
import { motion, AnimatePresence } from 'framer-motion';

const ChatBot = ({suggestionText,style}) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="chatbotmain_box" style={{...style}}>
      <>
        {/* <div className="chatlogo_box">
          <Lottie
            onClick={() => setOpen(!open)}
            animationData={chatlogo}
            loop={true}
            autoplay={true}
            style={{ width: 80, height: 80,cursor:'pointer' }}
          />
          <div className="notification-count">0</div>
        </div> */}
        {/* <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 50 }}
            transition={{ duration: 0.4 }}
          >
            <ChatBotBox setOpen={setOpen} ChatBotimage={chatlogo} suggestionText={suggestionText} />
          </motion.div>
        )}
      </AnimatePresence> */}
      </>
    </div>
  );
};

export default ChatBot;
